<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconClose_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M4.234 4.234a.8.8 0 0 1 1.132 0L8 6.868l2.634-2.634.061-.054a.8.8 0 0 1 1.07 1.185L9.131 8l2.634 2.635.055.061a.8.8 0 0 1-1.185 1.07L8 9.131l-2.635 2.634-.06.055a.8.8 0 0 1-1.07-1.186l2.633-2.635-2.634-2.634-.054-.06a.8.8 0 0 1 .054-1.07"
    />
</svg>
